import { toast } from 'sonner';
import { toastViewAction } from '~/utils/toast';

/** The type of action performed on a pin (move, copy, or save). */
type ActionTakenType = 'moved' | 'copied' | 'saved';

interface OnSucessProps {
    actionTaken: ActionTakenType;
    boardName: string;
    pinCount: number;
    urlSegment: string;
}

export const useOnSuccessToast = () => {
    const onSuccessToast = ({
        actionTaken,
        boardName,
        pinCount,
        urlSegment,
    }: OnSucessProps) => {
        const href = `/member/design-boards${urlSegment ? `/${urlSegment}` : ''}`;
        const message =
            pinCount === 1
                ? `Pin has been ${actionTaken} to "${boardName}"`
                : `${pinCount} pins ${actionTaken} to "${boardName}"`;
        toast.success(message, {
            action: toastViewAction(href, 'View board'),
        });
    };

    return { onSuccessToast };
};
